export const KYB_META_EXTRA_KEY = 'kyb_meta'
export const PROFILE_TYPE_EXTRA_PROPERTY = 'profile_type'
export const PAYBIS_POPUP_SKIP_COUNTER_EXTRA_KEY = 'tc_paybis_popup_skip_counter'

export const UserExtraKey = {
    PROFILE_TYPE: PROFILE_TYPE_EXTRA_PROPERTY,
    KYB_META: KYB_META_EXTRA_KEY,
    PAYBIS_POPUP_SKIP_COUNTER: PAYBIS_POPUP_SKIP_COUNTER_EXTRA_KEY,
} as const

